import antdEnUS from 'antd/es/locale/en_US';
import antdFrFR from 'antd/es/locale/fr_FR';
import antdNlNL from 'antd/es/locale/nl_NL';
import antdDeDE from 'antd/es/locale/de_DE';
import antdEsES from 'antd/es/locale/es_ES';
import en from './locales/en_US.json'
import fr from './locales/fr_FR.json'
import nl from './locales/nl_BE.json'
import de from './locales/de_DE.json'
import es from './locales/es_ES.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const SUPPORTED_LANGS = ['en', 'nl', 'fr', 'de', 'es'];

const detectLanguage = () => {
  // 1. URL param ?lang=es (links sent by backend/marketing)
  const urlLang = new URLSearchParams(window.location.search).get('lang');
  if (urlLang && SUPPORTED_LANGS.includes(urlLang)) {
    localStorage.setItem('app_language', urlLang);
    return urlLang;
  }

  // 2. Previously saved preference
  const saved = localStorage.getItem('app_language');
  if (saved) return saved;

  // 3. Detect from browser language
  const browserLang = navigator.language?.split('-')[0]; // 'nl-BE' → 'nl'
  if (SUPPORTED_LANGS.includes(browserLang)) return browserLang;

  return 'en';
};

const savedLanguage = detectLanguage();

export const resources = {
    en: {
        translation: en,
        antd: antdEnUS
    },
    fr: {
        translation: fr,
        antd: antdFrFR
    },
    nl: {
        translation: nl,
        antd: antdNlNL
    },
    de: {
        translation: de,
        antd: antdDeDE
    },
    es: {
        translation: es,
        antd: antdEsES
    },
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: 'en',
    lng: savedLanguage,
    interpolation: {
        escapeValue: false
    }
})

export default i18n;